/* eslint-disable no-unused-vars */
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { connect } from 'react-redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';

import forms from './components/routes/forms/forms-dux';
import clients from './components/routes/client/clients-dux';
import codes from './components/routes/codes/reg-code-dux';

import app from './app-dux/app-dux';
import globalization from './app-dux/globalization-dux';
import company from './app-dux/company-dux';
import roster from './app-dux/roster-dux';

/*******************************************************************************
 *  Gather all the reducers
 */
const reducer = combineReducers( {
    app,
    company,
    roster,
    globalization,
    forms,
    codes,
    clients
} );

const middleware = [ thunk ];

//if ( window.location.port === '5000' ) {
    middleware.push( createLogger( {
        collapsed: true
    } ) );
//}

const AppStore = createStore(
    reducer,
    applyMiddleware( ...middleware )
);

export default AppStore;
